module.exports = __webpack_public_path__ + "static/img/aff6.8fd7bc6b.png";